import React from "react";
import TablaVentaCodigosCargados from "js/components/TablaVentaCodigosCargados";

function VentaCodigoCargado(props) {
  return <TablaVentaCodigosCargados />;
}

export default VentaCodigoCargado;
